import { render, staticRenderFns } from "./NotServices.vue?vue&type=template&id=758ef6b5&scoped=true&"
import script from "./NotServices.vue?vue&type=script&lang=js&"
export * from "./NotServices.vue?vue&type=script&lang=js&"
import style0 from "./NotServices.vue?vue&type=style&index=0&id=758ef6b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758ef6b5",
  null
  
)

export default component.exports